import React from 'react'
import type { ComponentType, SVGProps } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import iconList from './icon-list'
import style from './index.module.scss'

const icons = import.meta.glob('./assets/*/*.inline.svg', {
  eager: true,
  query: '?react',
  import: 'default',
}) as Record<string, ComponentType<SVGProps<SVGSVGElement>>>

interface IconProps {
  size?: 'small' | 'medium' | 'large'
  type: string
  className?: string
}

const Icon = ({
  size = 'medium',
  type,
  className,
  ...iconProps
}: IconProps) => {
  const IconSVG = icons[`./assets/${size}/${type}.inline.svg`]

  return IconSVG ? (
    <IconSVG className={classNames(style.Icon, className)} {...iconProps} />
  ) : null
}

const validateType = (props: IconProps) => {
  const { size = 'medium', type } = props
  if (!type) {
    return new Error('Prop type is required for Icon')
  }
  if (!size || !iconList[size].includes(type)) {
    return new Error(`Invalid type, or size combination for icon: ${type}`)
  }
  return null
}

Icon.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  type: validateType,
  className: PropTypes.string,
}

export default Icon
